import { ErrorCard, FormattedMessageDiv, LoadingCard } from '@odmonorepo/core-components';
import { Tabs, Tab, Collapse, Stack, Card, Alert } from 'react-bootstrap';
import LoanDetails from '../Components/LoanDetails';
import UpcomingPayments from '../Components/UpcomingPayments';
import { useIntl } from 'react-intl';
import { rawLoanToLoanDetails } from '../Transformers/rawLoanToLoanDetails';
import { useNavigate } from '@tanstack/react-router';
import { IFEligibleSignUp } from '../Components/IFEligibleSignUp';
import { IFRegistered } from '../Components/IFRegistered';
import { BorrowingDetails } from '../Components/BorrowingDetails';
import { useLOC, getLOCPayment, getTLPayment, useBatchLoan } from 'merchant-api/spiceroad';

export function ProductCard() {
  const intl = useIntl();
  const { activeTL, loanLoading, loanError } = useBatchLoan();
  const { activeLOC, locLoading, locError, cardRegistered, isPaidInFull, ifEnabled } = useLOC();
  const { LOCPayment, LOCPaymentLoading } = getLOCPayment();
  const { loanPayment, loanPaymentLoading } = getTLPayment();
  const navigate = useNavigate();

  if (loanError || locError)
    return <ErrorCard name={intl.formatMessage({ id: 'loading.error' })} />;
  if (loanLoading || locLoading) return <LoadingCard />;
  const showProdCard =
    activeLOC || (activeTL && activeTL?.percentagePaidDown != 100);

  let modifiedLocPayment = LOCPayment! && {
    payment: {
      amount: LOCPayment?.nextPaymentAmount,
      scheduledDate: LOCPayment?.nextPaymentDate,
    },
    ...LOCPayment,
  };
  return (
    showProdCard && (
      <Card className="p-5">
        <Tabs className="d-flex justify-content-center custom-tabs">
          {activeLOC && (
            <Tab
              className="pt-5"
              title={intl.formatMessage({ id: 'title.loc' })}
              eventKey="Line of Credit"
            >
              <Stack gap={5}>
                <LoanDetails
                  {...rawLoanToLoanDetails(activeLOC)}
                  btnOnClick={() => {
                    navigate({to: '/drawfunds'});
                  }}
                />
                {activeLOC?.availableCredit < 1000 && (
                  <Alert variant="warning" className="fs-7 mb-0">
                    <FormattedMessageDiv id="drawFunds.lessThanThousand.title" className="fs-6 fw-bold" />
                    <FormattedMessageDiv id="drawFunds.lessThanThousand.message" />
                  </Alert>
                )}
                <BorrowingDetails apr={activeLOC.annualPercentageRate} cod={activeLOC.trueCOD} monthlyInterest={activeLOC.monthlyInterestRate} />
                {cardRegistered ? (
                  <IFRegistered className="border-top pt-5 border-light-medium-gray" />
                ) : (
                  ifEnabled && <IFEligibleSignUp className="mb-2" />
                )}
                <Collapse in={(!LOCPaymentLoading || LOCPayment !== undefined) && !isPaidInFull}>
                  <div>
                    <UpcomingPayments
                      className="border-top pt-5 border-light-medium-gray"
                      {...modifiedLocPayment}
                    />
                  </div>
                </Collapse>
              </Stack>
            </Tab>
          )}
          {activeTL && activeTL?.percentagePaidDown != 100 && (
            <Tab
              className="pt-5"
              title={intl.formatMessage({ id: 'title.termloan' })}
              eventKey="Term Loan"
            >
              <Stack gap={5}>
                <LoanDetails
                  {...rawLoanToLoanDetails(activeTL)}
                  showRangePercentage
                />
                <Collapse in={!loanPaymentLoading || loanPayment !== undefined}>
                  <div>
                    <UpcomingPayments
                      className="border-top pt-5 border-light-medium-gray"
                      {...loanPayment!}
                    />
                  </div>
                </Collapse>
              </Stack>
            </Tab>
          )}
        </Tabs>
      </Card>
    )
  );
}

export default ProductCard;
